import "@/styles/print/print.css";
import store from "@/store";
import { operatorLogoUrl } from "@/util/assets";

export default {
  install(Vue) {
    var domain = Vue.prototype.$domain();

    Vue.prototype.$printDocument = (content) => {
      let stylesFonts = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"]'),
      ]) {
        stylesFonts += node.outerHTML;
      }

      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('style[type="text/css"]'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const win = window.open("about:blank");

      win.document.write(
        `<!DOCTYPE html>
          <html>
            <head>
              <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">
              <title>Imprimir</title>
              ${stylesFonts}
              ${stylesHtml}
            </head>
            <body id="view-print" onafterprint="self.close()">
              <div class="v-application v-application--is-ltr" id="app">
                <div class="v-application--wrap">
                  <div class="">
                    <div class="text-center">
                      <img
                        style="max-width:45px;"
                        src="${operatorLogoUrl(domain)}"
                      />
                    </div>
                    ${content}
                  </div>
                </div>
              </div>
            </body>
          </html>
      `
      );

      win.document.close();
      win.focus();

      setTimeout(function() {
        win.print();
      }, 300);
    };

    //
    // LEVEL USER AGENT
    //

    Vue.prototype.$printBet = function() {
      var bet = document.getElementById("bet-card").innerHTML;
      var type = "getPrint";
      print(bet, domain, type);
    };

    Vue.prototype.$printTable = function() {
      var table = document.getElementById("table-print").innerHTML;
      var type = "getPrint";
      print(table, domain, type);
    };

    Vue.prototype.$agentPrintBt = function() {
      var table = document.getElementById("bigtable-print").innerHTML;
      var type = "getPrintBt";
      print(table, domain, type);
    };

    // shareBet - (PDF);
    Vue.prototype.$shareBet = function() {
      var bet = document.getElementById("bet-card").innerHTML;
      var id_bet = store.state.betCard.id;
      var type = "getShare";
      print(bet, domain, type, id_bet);
    };

    //
    // LEVEL USER FINAL
    //

    // printBetUSER;
    Vue.prototype.$printBetUser = function() {
      var bet = document.getElementById("bet-card-user").innerHTML;
      var type = "getPrint";
      print(bet, domain, type);
    };

    // shareBetUser (PDF);
    Vue.prototype.$shareBetUser = function(id_bet) {
      var bet = document.getElementById("bet-card-user").innerHTML;
      var type = "getShare";
      print(bet, domain, type, id_bet);
    };
  },
};

// Get 'Fonts' and 'I cons':
let stylesFonts = "";
for (const node of [...document.querySelectorAll('link[rel="stylesheet"]')]) {
  stylesFonts += node.outerHTML;
}

// Get 'text/css' HTML:
let stylesHtml = "";
for (const node of [...document.querySelectorAll('style[type="text/css"]')]) {
  stylesHtml += node.outerHTML;
}

// Function Print:
const print = (dataPrint, domain, type, id_bet) => {
  // <body onafterprint="self.close()">

  const win = window.open("about:blank");
  win.document.write(
    `<!DOCTYPE html>
    <html>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">      
        <title>Imprimir</title>                
        ${stylesFonts}                     
        ${stylesHtml}
      </head>
      <body id="view-print" onafterprint="self.close()">
        <div class="v-application v-application--is-ltr" id="app">            
          <div class="v-application--wrap">
            <div class="mx-auto" style="width:${
              type === "getPrintBt" ? "70%" : "80mm"
            }">
              <div class="text-center">
                <img
                  style="max-width:100px; margin-top:10px"                        
                  src="${operatorLogoUrl(domain)}"
                />
              </div>
              <div id="capture">
                ${dataPrint}
              </div>
            </div>
          </div>
        </div>
      </body>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.3.5/jspdf.debug.js"></script>         
      <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.5.0-alpha1/html2canvas.min.js"></script>
      <script type="text/javascript">
        var getShare = '${type}'        
        if(getShare === 'getShare'){
          var body = document.body;
          var html = document.documentElement;  
          var height = Math.max( body.scrollHeight, body.offsetHeight, 
                                html.clientHeight, html.scrollHeight, html.offsetHeight );
          html2canvas(document.querySelector("#capture"), {useCORS: true, imageTimeout:0, allowTaint: true}).then(canvas => {          
            return canvas.toDataURL('image/png')        
          }).then(imgdata => {                        
            var doc = new jsPDF("p", "px", [316, height + 16])
            doc.addImage(imgdata, 'PNG', 8, 8, 300, height)
            doc.save('Aposta-Cod-${id_bet}.pdf')
          })
        }
      </script>
    </html>`
  );
  win.document.close();
  win.focus();

  if (type === "getPrint" || type === "getPrintBt") {
    setTimeout(function() {
      win.print();
    }, 1000); // fix. setTimeout resolve error build production.
  }

  // if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  //   setTimeout(function () { win.print(); }, 300); // fix. setTimeout resolve error build production.
  // }
};
